import React, { useEffect, useState } from "react";
import Base from "../utils/base";

import Header from './components/Header'
import Feature from './components/Feature'
import ListRoom from './components/ListRoom'

export default function Rooms(props) {
	var base = new Base();

	return (
		<>
			<Header/>
			<Feature/>
			<ListRoom/>
		</>
	);
};
